import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "radio" }
const _hoisted_2 = ["value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        type: "radio",
        class: "radio",
        value: _ctx.value,
        checked: _ctx.modelValue === _ctx.value,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, null, 40, _hoisted_2),
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
    ])
  ]))
}